import { defineComponent as _defineComponent } from 'vue'

const __default__ = {
  name: 'UniversalLoginModal',
};

import { computed, useStore, useContext, useRouter, ref } from '@nuxtjs/composition-api';
import ModalBase from '~/components/modals/ModalBase.vue';
import TsButton from '~/components/atoms/Button.vue';
import TsTesLogo from '~/components/svg/TsTesLogo.vue';
import { State } from '~/store';


export default /*#__PURE__*/_defineComponent({
  ...__default__,
  emits: ['close', 'logged-in', 'skip-for-now', 'login'],
  setup(__props, { emit: $emit }) {

const { localePath } = useContext();

const store = useStore<State>();
const $router = useRouter();

const close = async (path?: string) => {
  try {
    await store.dispatch('toggleUniversalLoginModal', false);
    if (path) {
      $router.push(localePath(path));
    }
  } catch (e) {
    console.error(e);
  }
};

const password = ref<string>('');
const universalLoginStatus = computed(() => store.getters.universalLoginStatus);


return { __sfc: true,localePath, store, $router, close, password, universalLoginStatus, $emit, ModalBase, TsButton, TsTesLogo }
}

})